import React, { FC } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { RocheUIStageHomeTeaser } from '@repo/roche-ui';
import { blokToComponent } from '../../helpers/blok-to-component';

export type RocheStageHomeTeaserProps = BlokToComponentProps<{
  teaser_title: string;
  teaser_description: string;
  slotted_button: any[];
  hasMarginTop: boolean;
}>;

export const RocheStageHomeTeaser: FC<RocheStageHomeTeaserProps> = ({ blok, getComponent }) => {
  const slottedButton = blok.slotted_button?.map((button) =>
    blokToComponent({ getComponent, blok: button, hasMarginTop: false } as BlokToComponentProps<any>, 'button'),
  );

  return (
    <RocheUIStageHomeTeaser teaserTitle={blok.teaser_title} teaserDescription={blok.teaser_description}>
      {slottedButton}
    </RocheUIStageHomeTeaser>
  );
};
